import { Field } from "@progress/kendo-react-form";
import type { KeyValue, FieldValidatorType } from "@progress/kendo-react-form";
import { currencyCodeValidator } from "@iliotech/data-wire";
import * as React from "react";
import { Autocomplete, AutocompleteProps } from "../Autocomplete/Autocomplete";

interface IOwnProps extends Omit<AutocompleteProps, "name" | "label"> {
  errors: KeyValue<string>;
  name?: string;
  label?: string | null;
  allCurrencies?: Set<string> | undefined | string[];
  validator?: FieldValidatorType | FieldValidatorType[] | undefined;
}

export const CurrencySearchField = ({
  errors,
  name = "currency",
  label = "Currency",
  defaultValue,
  allCurrencies,
  validator,
  ...rest
}: IOwnProps) => {
  const memoData = React.useMemo(
    () => [...((allCurrencies ?? []) as string[])],
    [allCurrencies]
  );
  const [open, setOpen] = React.useState(false);
  const component = React.useMemo(
      () => (props: AutocompleteProps) =>
          (
              <Autocomplete
                  {...props}
                  defaultValue={defaultValue}
                  opened={open}
                  onOpen={() => setOpen(true)}
                  onClose={() => setTimeout(() => setOpen(false), 100)}
                  onFocus={() => setOpen(true)}
              />
          ),
      [open, setOpen]
  );

  if (!allCurrencies) return null;

  return (
    <Field
      component={component}
      label={label}
      name={name}
      error={errors?.[name]}
      // defaultValue={defaultValue}
      placeholder={"Enter currency"}
      validator={validator || currencyCodeValidator}
      data={memoData}
      filterData={(filter?: string) => {
        return (memoData as string[])?.filter((item: any) =>
          (item ?? "").toLowerCase().startsWith(filter?.toLowerCase() ?? "")
        );
      }}
      {...rest}
    />
  );
};
